export default __webpack_public_path__ + "static/media/rt_layout.c2e66777.svg";